import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { Config } from 'src/infrastructure/config';
import { UserDTO } from 'src/models/DTO/user/user';
import { LocalstorageService } from 'src/services/core/localstorage/localstorage.service';
import { UserService } from 'src/services/core/user/user.service';
import { GroupsService } from 'src/services/request/groups/groups.service';
import { LoggedUserService } from 'src/services/state/loggeduser/loggeduser.service';

@Component({
  selector: 'app-bottomtabs',
  templateUrl: './bottomtabs.component.html',
  styleUrls: ['./bottomtabs.component.css']
})
export class BottomtabsComponent implements OnInit {

  public goToMobileApp = '';
  public homeURL: string = 'bottomtabs/home';
  public cartURL: string = 'bottomtabs/cart';
  public groupsURL: string = 'bottomtabs/groups';
  public accountURL: string = 'bottomtabs/settings';
  private _loggedUser?: UserDTO;
  private _isThereNewGroup: boolean = false


  constructor(
    private router: Router,
    private localStorage: LocalstorageService,
    private userStateService: LoggedUserService,
    private userService: UserService,
    private modalService: NgbModal,
    private groupsService: GroupsService
  ) {

    this.userStateService.userInfo$.subscribe((user) => {
      this._loggedUser = user;
    })
    this.callToUpdateNewGroupsFlag();
  }

  private callToUpdateNewGroupsFlag() {
    this.groupsService.getFilteredGroups(1, 1, '', '-created', {filters: []}).subscribe(groups => {
      if (groups.data.length) {
        this.updateIsThereNewGroupFlag(groups.data[0].uuid);
      }
    })
  }

  private updateIsThereNewGroupFlag(newGroup: string) {
    if (!this.localStorage.getLocalStorageItem(Config.lsLastGroup) || 
        this.localStorage.getLocalStorageItem(Config.lsLastGroup)  != newGroup) {
      this._isThereNewGroup = true;
    }
    if (this.currentLink == this.groupsURL) {
      this._isThereNewGroup = false;
      this.localStorage.setLocalStorageItem(Config.lsLastGroup, newGroup) 
    }
  }

  ngOnInit(): void {
  }

  get isThereNewGroup() {
    return this._isThereNewGroup;
  }

  get user() {
    return this._loggedUser;
  }

  get currentLink() {
    return this.localStorage.getLocalStorageItem(Config.bottomTapPageKey) || 'bottomtabs/home';
   }

   get isUserLogged() {
    return this.userService.isUserLogged();
  }

  goTo(link: string) {
    this.localStorage.setLocalStorageItem(Config.bottomTapPageKey, link);
    this.router.navigate([link]).then(() => {
      if (link == this.homeURL && !this.localStorage.getLocalStorageItem(Config.lsCatFromMain)
          && !this.localStorage.getLocalStorageItem(Config.lastSearchTextKey)
          && !this.localStorage.getLocalStorageItem(Config.lastSearchTextKeyGroups)) {
        window.location.reload();
      }
    });
    this.callToUpdateNewGroupsFlag();
  }

  goToCart(loginModal: any) {
    if (!this.isUserLogged) {
      this.modalService.open(loginModal, { size: 'sm',  windowClass: 'loginModal' })
      return;
    }
    this.goTo(this.cartURL);
    this.router.navigate(['bottomtabs/cart'])
  }

  loginNavigation(currentModal: any) {
    currentModal.close();
    this.router.navigate(['login']);
  }

  goToGooglePlay(){
    window.location.href = this.goToMobileApp;
  }

  registration(currentModal: any) {
    currentModal.close();
    this.router.navigate(['registration']);
  }

  groupCSSButton() {
    return "font-style: normal; background-color: red;border-radius: 20px;color: white;height: 10px;left: -20px;padding:0px;position: relative;top: -8px;width: 10px;display: inline-block;"

  }

  getCartButtonStyle(numberOfCartLines: number) {
    if (numberOfCartLines < 10) {
      return "font-style: normal; background-color: red;border-radius: 20px;color: white;height: 22px;left: -20px;padding: 1px 14px 1px 6px;position: relative;top: -8px;width: 20px;display: inline-block;"
    }
    else {
      return "font-style: normal; background-color: red;border-radius: 20px;color: white;height: 22px;left: -20px;padding: 1px 14px 1px 6px;position: relative;top: -8px;width: 30px;display: inline-block;"
    }
  }
}
